import React from 'react'
import { Link } from 'gatsby'
import { Flex, Button, Heading, Text } from 'theme-ui'
import { FaLightbulb } from 'react-icons/fa'

const styles = {
  wrapper: {
    alignItems: `center`,
    flexDirection: `column`,
    bg: `omegaLighter`,
    borderRadius: `lg`,
    size: `full`,
    p: 4,
  },
  heading: {
    fontSize: 5,
    color: `omegaDark`,
    wordSpacing: 500, //force line breaks
    svg: {
      color: `beta`,
      size: `icon.lg`,
      display: `block`,
      mb: 3,
    },
  },
  subheading: {
    color: `omegaDark`,
    fontWeight: `bold`,
    fontSize: 2,
  },
  list: {
    color: `omegaDark`,
    listStyle: `none`,
    m: 0,
    p: 0,
    li: {
      p: 0,
      my: 2,
    },
    'li:before': {
      content: `""`,
      display: `inline-block`,
      width: `icon.xs`,
      bg: `success`,
      borderRadius: `full`,
      size: `7px`,
      mr: `7px`,
    },
  },
  button: {
    display: `block`,
    mt: `60px`,
    fontSize: `16px`,
  },
}

const BannerVertical = () => (
  <Flex sx={styles.wrapper}>
    <Heading variant='h2' sx={styles.heading}>
      <FaLightbulb /> 「モラル」に関するプログラムを開発中
    </Heading>
    <Heading variant='h3' sx={styles.subheading}>
    モラルを護るためのヒントが描かれているおすすめの映画を募集しています <br /> <br />
    <Button as={Link} to='/archive/#%EF%BC%93%E8%AA%BF%E6%9F%BB%E7%B5%90%E6%9E%9C' variant="outlined" color="success">
      モラルを護るためのヒントが描かれている映画とは？
    </Button>
    <Button
      variant='primary'
      as={Link}
      to='https://jp.surveymonkey.com/r/RH2H9YT'
      target="_blank"
      sx={styles.button}
      aria-label='ご応募はこちらから'
    >
      ご応募はこちらから
    </Button>
  </Heading>
  </Flex>
)

export default BannerVertical
